import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useHistory } from 'react-router';
import { getTestIds } from 'seagull/utils/TestIds';
import { routes } from '~/constants';
import { useIoContext, useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { integrationModel } from '~/models';
import IntegrationCard from '../IntegrationCard/IntegrationCard';
import financialCentsLogoUrl from './financial-cents-logo.png';
const deprecatedTestIds = {
    FinancialCentsCardTID: {
        Root: ()=>'financial-cents-card',
        Connect: ()=>'financial-cents-connect',
        ManageConnection: ()=>'financial-cents-manage-connection'
    }
};
export const GetFinancialCentsCardTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds
    });
const FinancialCentsCard = (param)=>{
    let { integration } = param;
    const { t: texts } = useLocaleKeys('integrations.availableApps.financialCents');
    const { t: sharedTexts } = useLocaleKeys('integrations.availableApps.shared');
    const { FinancialCentsCardTID } = useMemo(()=>GetFinancialCentsCardTID(), []);
    const { api } = useStoreActions();
    const { changeLocation } = useIoContext();
    const history = useHistory();
    const isLinked = integrationModel.isLinked(integration);
    const buttonProps = isLinked ? {
        bi: {
            name: 'manage_financial_cents_connection'
        },
        testId: FinancialCentsCardTID.ManageConnection(),
        children: sharedTexts.manageConnection(),
        onClick: ()=>history.push(routes.financialCentsSetup)
    } : {
        bi: {
            name: 'connect_financial_cents'
        },
        testId: FinancialCentsCardTID.Connect(),
        children: sharedTexts.connectButton(),
        onClick: async ()=>{
            const redirectUrl = "".concat(window.location.origin).concat(routes.financialCentsSetup);
            const linkUrl = await api.financialCents.connect(redirectUrl);
            const connectUrl = new URL(linkUrl);
            connectUrl.searchParams.append('host', window.location.host);
            changeLocation(connectUrl.toString());
        }
    };
    return /*#__PURE__*/ _jsx(IntegrationCard, {
        testId: FinancialCentsCardTID.Root(),
        title: texts.title(),
        subTitle: texts.subTitle(),
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, _object_spread({}, buttonProps)),
        icon: /*#__PURE__*/ _jsx(IntegrationCard.LogoImg, {
            alt: "financial cents logo",
            src: financialCentsLogoUrl
        }),
        disclaimer: texts.disclaimer()
    });
};
export default FinancialCentsCard;
